<template>
  <b-row class="border-right d-flex align-items-center">
    <b-col>
      <b-form-group
        label="Arama"
        label-for="keywords"
      >
        <b-form-input
          id="keywords"
          v-model="filterParams.keywords"
          placeholder="Hizmet Adı, Hizmet Kodu..."
          @keydown.enter="getDataList"
        />
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group
        label="Hizmet Kategorisi"
        label-for="id_service_categories"
      >
        <v-select
          id="id_service_categories"
          v-model="filterParams.id_service_categories"
          :options="categories"
          :reduce="item => item.id"
          label="title"
          placeholder="Hizmet Kategorisi"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="auto"
    >
      <b-button
        style="margin-top: 2px"
        variant="danger"
        @click="getDataList"
      >
        <FeatherIcon icon="SearchIcon" />
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BButton, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'FilterCard',
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    vSelect,
  },
  props: {
    getDataList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    categories() {
      return this.$store.getters['serviceCategories/dataList']
    },
    filterParams() {
      return this.$store.getters['services/filterParams']
    },
  },
  created() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      this.$store.dispatch('serviceCategories/getDataList', {
        select: [
          'service_categories.id AS id',
          'service_categories.title AS title',
        ],
        where: {
          'service_categories.status': 1,
        },
      })
    },
  },
}
</script>
